import { useRecoilState, useRecoilValue } from "recoil";
import { useToken } from "states/auth/hooks";
import { useLoadItems } from "states/figure/hooks";
import { currentIdState, itemState } from "states/figure";
import { create, update } from "api/figure";
import DetailsForm from "./DetailsForm";

const stateName = "figure";

const Details = () => {
  const [currentId, setCurrentId] = useRecoilState(currentIdState(stateName));
  const currentItem = useRecoilValue(
    itemState({ name: stateName, id: currentId })
  );
  const loadItems = useLoadItems(stateName);
  const token = useToken();

  const save = async (item: Figure) => {
    if (currentId) {
      await update({
        id: currentId,
        entity: item,
        token,
      });
    } else {
      const { data } = await create({
        entity: item,
        token,
      });

      if (data) setCurrentId(data._id);
    }

    await loadItems();
  };

  return <DetailsForm id={currentId} item={currentItem} onSave={save} />;
};

export default Details;
